import {
  CodeConfigurationField,
  LandingPageDestination
} from '@dtx-company/inter-app/src/types/flowcode'
import { FC, useRef } from 'react'
import { ScanDestinationFieldProps } from '../ScanDestination'
import { TextField } from '@dtx-company/design-system/src'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import {
  selectError,
  selectNormalizedScanDestination
} from '@dtx-company/app/shared/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@dtx-company/app/shared/common/src/hooks/useGlobalServices'
import { useOnChange } from '../hooks/useOnChange'
import { useOnErrorScrollInToView } from '../hooks/useOnErrorScrollInToView'
import { useScanDestinationOptions } from '../hooks/useScanDestinationOptions'
import { useSelector } from '@xstate/react'
import useTranslation from 'next-translate/useTranslation'

export const YouTubeField: FC<ScanDestinationFieldProps> = ({ size = 'large' }) => {
  const { t } = useTranslation('logged-out-generator')
  const scanDestinationOptions = useScanDestinationOptions()
  const { locgService } = useGlobalServices()
  const normalizedScanDestination = useSelector(locgService, selectNormalizedScanDestination)
  const { Icon } = scanDestinationOptions[LandingPageDestination.YOUTUBE]
  const error = useSelector(locgService, selectError)(CodeConfigurationField.SCAN_DESTINATION)
  const ref = useRef<HTMLInputElement>(null)

  useOnErrorScrollInToView(Boolean(error), ref)

  const onChange = useOnChange()

  return (
    <TextField
      size={size}
      name={CodeConfigurationField.SCAN_DESTINATION}
      label={t('LoggedOutGenerator.ScanDestination.options.youtube.label')}
      hiddenLabel
      value={normalizedScanDestination}
      placeholder={t(
        'LoggedOutGenerator.ScanDestination.options.youtube.subcomponents.YouTubeInput.placeholder'
      )}
      type="url"
      startAdornment={<Icon sx={{ color: 'onSurface.secondary' }} />}
      onChange={onChange}
      onFocus={() => fireAnalyticsEvent('LoggedOutGenerator_ScanDestinationInputYouTube_Focused')}
      onBlur={e => {
        fireAnalyticsEvent('LoggedOutGenerator_ScanDestinationInputYouTube_Blurred', {
          text: e.target.value
        })
      }}
      inputProps={{
        'data-heap-id': 'LoggedOutGenerator_ScanDestinationInputYouTube',
        ref
      }}
      error={!!error}
      helperText={error}
    />
  )
}
